module.exports = __webpack_public_path__ + "88fcc5abf41ecf3090bedbf7eab259dd.svg";